<script>
import Layouts from '@/layouts/Layouts.vue';
import core from '@/core';

export default {
  data: () => ({
    core,
  }),
  components: {
    Layouts,
  },
  mounted() {
  },
};
</script>
<template>
  <Layouts v-if="core.show"></Layouts>
</template>
<style lang="scss">
  html,
  body {
    margin: 0;
  }

  body {
    background-color: #f5f5f5;
  }

  * {
    box-sizing: border-box;
  }

  input, textarea, select, button {
    font-family: 'Roboto', serif;
  }
</style>
